import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Card, CardContent } from '../ui/card';
import { Progress } from '../ui/progress';

const LicenseUsageTile = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchLicenseData = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/superadmin-stats/license-usage`, {
          withCredentials: true,
        });
        setData(res.data);
      } catch (err) {
        console.error('Fehler beim Laden der Lizenznutzung:', err);
      }
    };
    fetchLicenseData();
  }, []);

  return (
    <Card className="h-full">
      <CardContent className="p-6">
        <h3 className="text-sm text-gray-400">Lizenznutzung je Kunde</h3>
        <div className="space-y-4 mt-4">
          {data.map((entry, index) => {
            const pairRate = Math.round((entry.activePairs / entry.maxPairs) * 100);
            const hrRate = Math.round((entry.activeHR / entry.maxHR) * 100);

            return (
              <div key={index} className="text-sm">
                <div className="font-medium text-white">{entry.company} ({entry.package})</div>

                <div className="mt-1 text-xs text-gray-400">Mentoring-Paare: {entry.activePairs} / {entry.maxPairs}</div>
                <Progress value={pairRate} className="h-2 bg-gray-800 mb-2" />

                <div className="text-xs text-gray-400">HR-Accounts: {entry.activeHR} / {entry.maxHR}</div>
                <Progress value={hrRate} className="h-2 bg-gray-800" />
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
};

export default LicenseUsageTile;
